export function getHeapTrackerUserOrgRoleString(role: string | undefined): string | undefined {
  if (!role) return
  return role.replace(/^org_role:/, '').toUpperCase()
}
